export default "__VITE_ASSET__Cnpd87M1__"